import React, { useEffect, useState } from "react";
import { Menu, X, LayoutDashboard } from "lucide-react";
import { MARKETING_PANEL } from "@/lib/marketingPanel";
import HeaderLogo from "@/components/HeaderLogo";

const NAV = [
  { label: "Home", href: "#home" },
  { label: "Commodities", href: "#commodities" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-md border-b border-slate-200/60 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-8 min-h-[4rem] md:min-h-[5.25rem] py-2 md:py-2.5">
        <a
          href="#home"
          data-testid="logo-link"
          className="inline-flex shrink-0 items-center bg-transparent p-0 rounded-none shadow-none ring-0"
        >
          <HeaderLogo />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={MARKETING_PANEL.dashboard}
            data-testid="header-dashboard-btn"
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-slate-700 border border-slate-200 rounded-full hover:border-blue-300 hover:text-blue-600 btn-press"
          >
            <LayoutDashboard size={16} />
            Dashboard
          </a>
          <a
            href={MARKETING_PANEL.signIn}
            data-testid="header-signin-btn"
            className="px-4 py-2 text-sm font-semibold text-slate-700 hover:text-blue-600 transition-colors btn-press"
          >
            Sign In
          </a>
          <a
            href={MARKETING_PANEL.signUp}
            data-testid="header-signup-btn"
            className="px-5 py-2.5 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-full shadow-sm hover:shadow-md btn-press"
          >
            Sign Up
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-slate-700"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-slate-200 shadow-lg"
        >
          <div className="px-5 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-base font-semibold text-slate-700 py-2"
              >
                {n.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 pt-2">
              <a
                href={MARKETING_PANEL.dashboard}
                data-testid="mobile-dashboard-btn"
                onClick={() => setOpen(false)}
                className="text-center py-2.5 text-sm font-semibold text-slate-800 border border-slate-200 rounded-full"
              >
                Dashboard
              </a>
              <a
                href={MARKETING_PANEL.signIn}
                data-testid="mobile-signin-btn"
                onClick={() => setOpen(false)}
                className="text-center py-2.5 text-sm font-semibold text-slate-700 border border-slate-200 rounded-full"
              >
                Sign In
              </a>
              <a
                href={MARKETING_PANEL.signUp}
                data-testid="mobile-signup-btn"
                onClick={() => setOpen(false)}
                className="text-center py-2.5 text-sm font-semibold text-white bg-blue-600 rounded-full"
              >
                Sign Up
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
